import ItemSkill from "./itemSkill/ItemSkill";
import {imgIcon} from "./itemSkill/ItemSkillIcons";

import { useTranslation } from "react-i18next";

export default function MySkills() {
  const { t } = useTranslation();
  return (<>
    {/*
		<ItemSkill index={1} icon={imgIcon.reactImg} title="React JS" description={t('about-react')} />
    <ItemSkill index={2} icon={imgIcon.unityImg} title="Unity Engine" description={t('about-unity')} />
		*/}

	<ItemSkill index={1} icon={imgIcon.reactImg} title={t('title-front-end')} description={t('about-front-end')} />
	<ItemSkill index={2} icon={imgIcon.gameImg} title={t('title-game-dev')} description={t('about-game-dev')} />
	<ItemSkill index={3} icon={imgIcon.mobileImg} title={t('title-mobile-dev')} description={t('about-mobile-dev')} />

  </>);
}

